import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { getCustomer,deleteCustomer } from '../../redux/actions/customer/CustomerAction';
import CustomerTracking from '../Customer/CustomerTracking';

const CartCustomer = ({ customer,getCustomer,deleteCustomer,history }) => {

    const params=useParams();
    useEffect(()=>{
        getCustomer(params.customerId);
        console.log(customer);
    },[]);
    

    const handleDelete=(customerId)=>{
        deleteCustomer(customerId);
        history.push('/customer/login');
    };


    return (
        <>
        
            <table className="table table-hover table-dark">
                <thead>
                    <tr>
                        <th scope="col">Customer Id</th>
                        <th scope="col">First Name</th>
                        <th scope="col">Last-Name</th>
                        <th scope="col">email</th>
                        <th scope='col'>Address</th>
                        <th scope='col'>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr key={customer.customerId}>
                        <th scope="row">{customer.customerId}</th>
                        <td>{customer.firstName}</td>
                        <td>{customer.lastName}</td>
                        <td>{customer.email}</td>
                        <td>{customer.address}</td>
                        <td>
                            <Link
                                to={`/customer/update/${customer.customerId}`}
                                className="btn btn-primary mx-2"
                            >
                  Update
                            </Link>
                            <button
                                onClick={()=>handleDelete(customer.customerId)}
                                className="btn btn-danger"
                            >
                  Delete
                            </button>
                        </td>
                    </tr>
  
                </tbody>
            </table>
            <CustomerTracking id={customer.customerId}/>
        </>
    );
};

const mapStateToProps = (state) => {
    console.log(state.customers);
    return {customer: state.customers};
};
const mapDispatchToProps={getCustomer,deleteCustomer};

export default connect(mapStateToProps, mapDispatchToProps)(CartCustomer);
